import * as React from "react";
import "./Component467.css";
const Component467 = (props: { discharged: string, className?: string }) => {
  return (
    <div className={`component-467 ${props.className || ""}`}>
      {props.discharged || "Discharged"}
    </div>
  );
};
export default Component467;
